import { Component, input } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
	selector: 'lvr-chip',
	templateUrl: './chip.html',
	styleUrls: ['./chip.scss'],
	imports: [MatChip, MatIcon, TranslocoPipe],
})
export class LvrChip {
	public readonly name = input.required<string>();
	public readonly icon = input<string>('person');
	public readonly labelKey = input<string | null>(null);
}
